import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "reference-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "grid"
}
const _hoisted_5 = { class: "col sm:col-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col sm:col-6" }
const _hoisted_8 = { class: "pt-0" }
const _hoisted_9 = { class: "col sm:col-6" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "col sm:col-6" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "confirmation-title" }
const _hoisted_14 = { class: "col sm:col-6" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "confirmation-title" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col sm:col-12" }
const _hoisted_19 = { class: "col sm:col-12" }
const _hoisted_20 = { class: "caption char-count" }
const _hoisted_21 = { class: "col sm:col-12" }
const _hoisted_22 = { class: "col sm:col-12" }
const _hoisted_23 = { class: "caption char-count" }
const _hoisted_24 = { class: "col sm:col-12" }
const _hoisted_25 = { class: "col sm:col-12" }
const _hoisted_26 = { class: "caption char-count" }
const _hoisted_27 = { class: "col sm:col-12" }
const _hoisted_28 = { class: "col sm:col-12" }
const _hoisted_29 = { class: "caption char-count" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col sm:col-12" }
const _hoisted_32 = { class: "col sm:col-12" }
const _hoisted_33 = { class: "caption char-count" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col sm:col-12" }
const _hoisted_36 = { class: "col sm:col-12" }
const _hoisted_37 = { class: "caption char-count" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col sm:col-12" }
const _hoisted_40 = { class: "col sm:col-12" }
const _hoisted_41 = { class: "caption char-count" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col sm:col-12" }
const _hoisted_44 = { class: "col sm:col-2 text-center" }
const _hoisted_45 = { class: "col sm:col-2 text-center" }
const _hoisted_46 = { class: "col sm:col-2 text-center" }
const _hoisted_47 = { class: "col sm:col-2 text-center" }
const _hoisted_48 = { class: "col sm:col-4" }
const _hoisted_49 = { class: "col sm:col-2 text-center" }
const _hoisted_50 = { class: "col sm:col-2 text-center" }
const _hoisted_51 = { class: "col sm:col-2 text-center" }
const _hoisted_52 = { class: "col sm:col-2 text-center" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col col-12" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col sm:col-6" }
const _hoisted_57 = { class: "caption char-count" }
const _hoisted_58 = { class: "col sm:col-6" }
const _hoisted_59 = { class: "caption char-count" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col sm:col-6" }
const _hoisted_62 = { class: "caption char-count" }
const _hoisted_63 = { class: "col sm:col-6" }
const _hoisted_64 = { class: "caption char-count" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col sm:col-8" }
const _hoisted_67 = { class: "col sm:col-4" }
const _hoisted_68 = { class: "col sm:col-12" }
const _hoisted_69 = { class: "col sm:col-12" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { class: "confirmation-title" }
const _hoisted_72 = { class: "col sm:col-12" }
const _hoisted_73 = { class: "col sm:col-12" }
const _hoisted_74 = { class: "col sm:col-auto" }
const _hoisted_75 = { class: "col sm:col-auto" }
const _hoisted_76 = {
  key: 0,
  class: "col sm:col-12"
}
const _hoisted_77 = { class: "caption char-count" }
const _hoisted_78 = {
  key: 1,
  class: "col sm:col-12"
}
const _hoisted_79 = { class: "caption char-count" }
const _hoisted_80 = { class: "col sm:col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_Form = _resolveComponent("Form")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_external_layout = _resolveComponent("external-layout")!

  return (_openBlock(), _createBlock(_component_external_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.referenceRecord)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h4", null, [
                _createVNode(_component_TranslatedText, { path: "references.no-data" })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.referenceRecord?.completed && !_ctx.justCompleted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h4", null, [
                _createVNode(_component_TranslatedText, { path: "references.already-completed" })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.referenceRecord && (!_ctx.referenceRecord.completed || _ctx.justCompleted))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.translateText("references.referee.reference-for", [
              {
                placeholder: "name",
                value: `${_ctx.referenceRecord.reference.user.firstName} ${_ctx.referenceRecord.reference.user.surname}`,
              },
            ])), 1),
              _createVNode(_component_Form, {
                modelValue: _ctx.referenceRecordModel,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referenceRecordModel) = $event)),
                errors: _ctx.errorModelReference,
                "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.errorModelReference) = $event)),
                valid: _ctx.referenceValid,
                "onUpdate:valid": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referenceValid) = $event)),
                submitCheck: _ctx.submitCheckReferenceRef,
                "onUpdate:submitCheck": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.submitCheckReferenceRef) = $event)),
                schema: _ctx.schemaReference,
                class: "grid",
                ref: "referenceRecordForm"
              }, {
                default: _withCtx(({ handleDateUpdate, handleInputChange }) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h3", _hoisted_8, [
                        (_ctx.characterReferenceRecordModel === null)
                          ? (_openBlock(), _createBlock(_component_TranslatedText, {
                              key: 0,
                              path: "references.referee.employment-dates"
                            }))
                          : (_openBlock(), _createBlock(_component_TranslatedText, {
                              key: 1,
                              path: "references.character.dates-known"
                            }))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (_ctx.characterReferenceRecordModel !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " "))
                        : (_openBlock(), _createBlock(_component_Checkbox, {
                            key: 1,
                            additionalClasses: "nofade",
                            value: !!_ctx.referenceRecord?.presentDay,
                            error: _ctx.errorModelReference['dateFrom'],
                            disabled: 
                    _ctx.referenceRecordModel.completed === 'yes' ||
                    _ctx.justCompleted ||
                    _ctx.characterReferenceRecordModel !== null
                  ,
                            name: "presentDay",
                            id: "presentDay",
                            text: "references.reference-details.currently-working-referee",
                            onChange: handleInputChange
                          }, null, 8, ["value", "error", "disabled", "onChange"]))
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.characterReferenceRecordModel !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translateText("references.date-from")) + ": ", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.formatDatePickerDate(_ctx.referenceRecordModel.dateFrom)), 1)
                          ]))
                        : (_openBlock(), _createBlock(_component_DatePicker, {
                            key: 1,
                            required: 
                    !(
                      _ctx.referenceRecordModel.completed === 'yes' ||
                      _ctx.justCompleted ||
                      _ctx.characterReferenceRecordModel !== null
                    )
                  ,
                            disabled: 
                    _ctx.referenceRecordModel.completed === 'yes' ||
                    _ctx.justCompleted ||
                    _ctx.characterReferenceRecordModel !== null
                  ,
                            value: _ctx.referenceRecordModel.dateFrom,
                            error: _ctx.errorModelReference['dateFrom'],
                            onChange: handleDateUpdate,
                            label: "references.date-from",
                            name: "dateFrom",
                            id: "dateFrom"
                          }, null, 8, ["required", "disabled", "value", "error", "onChange"]))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.characterReferenceRecordModel !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.translateText("references.date-to")) + ": ", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.referenceRecord.presentDay
                      ? _ctx.translateText(
                          "references.reference-details.currently-aquintance"
                        )
                      : _ctx.formatDatePickerDate(_ctx.referenceRecordModel.dateTo)), 1)
                          ]))
                        : (_ctx.referenceRecord && !_ctx.referenceRecord.presentDay)
                          ? (_openBlock(), _createBlock(_component_DatePicker, {
                              key: 1,
                              required: 
                    !(
                      _ctx.referenceRecordModel.completed === 'yes' ||
                      _ctx.justCompleted ||
                      _ctx.characterReferenceRecordModel !== null
                    )
                  ,
                              disabled: 
                    _ctx.referenceRecordModel.completed === 'yes' ||
                    _ctx.justCompleted ||
                    _ctx.characterReferenceRecordModel !== null
                  ,
                              value: _ctx.referenceRecordModel.dateTo,
                              error: _ctx.errorModelReference['dateTo'],
                              onChange: handleDateUpdate,
                              label: "references.date-to",
                              name: "dateTo",
                              id: "dateTo"
                            }, null, 8, ["required", "disabled", "value", "error", "onChange"]))
                          : (_openBlock(), _createBlock(_component_FormInput, {
                              key: 2,
                              value: "Present Day",
                              error: _ctx.errorModelReference['presentDay'],
                              disabled: true,
                              label: "references.date-to",
                              name: "presentDayText",
                              id: "presentDayText"
                            }, null, 8, ["error"]))
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "errors", "valid", "submitCheck", "schema"]),
              (_ctx.referenceRecord.reference.employerReference)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 0,
                    modelValue: _ctx.employerReferenceRecordModel,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.employerReferenceRecordModel) = $event)),
                    errors: _ctx.errorModelEmployerReference,
                    "onUpdate:errors": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.errorModelEmployerReference) = $event)),
                    valid: _ctx.employerReferenceValid,
                    "onUpdate:valid": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.employerReferenceValid) = $event)),
                    submitCheck: _ctx.submitCheckEmployerReferenceRef,
                    "onUpdate:submitCheck": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.submitCheckEmployerReferenceRef) = $event)),
                    schema: _ctx.schemaEmployerReference,
                    class: "grid"
                  }, {
                    default: _withCtx(({ handleInputChange }) => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("h5", _hoisted_18, _toDisplayString(_ctx.translateText("references.referee.position-held", [
                    {
                      placeholder: "company",
                      value: `${_ctx.referenceRecord.reference.employerReference.company}`,
                    },
                  ])), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_FormInput, {
                            value: _ctx.employerReferenceRecordModel.userPosition,
                            error: _ctx.errorModelEmployerReference['userPosition'],
                            disabled: 
                    _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                  ,
                            onChange: handleInputChange,
                            label: "references.user-position",
                            name: "userPosition",
                            id: "userPosition",
                            required: true
                          }, null, 8, ["value", "error", "disabled", "onChange"]),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.charCount(_ctx.employerReferenceRecordModel, "userPosition", 100)), 1)
                        ])
                      ]),
                      (_ctx.tenant === 'north')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h5", _hoisted_21, [
                              _createVNode(_component_TranslatedText, { path: "references.referee.capacity" })
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_TextArea, {
                                value: _ctx.employerReferenceRecordModel?.capacity,
                                error: _ctx.errorModelEmployerReference['capacity'],
                                disabled: 
                    _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                  ,
                                onChange: handleInputChange,
                                label: "references.please-specify",
                                name: "capacity",
                                id: "capacity",
                                rows: 3,
                                placeholder: "form.placeholder",
                                labelAlwaysActive: "",
                                required: true
                              }, null, 8, ["value", "error", "disabled", "onChange"]),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.charCount(_ctx.employerReferenceRecordModel, "capacity", 1000)), 1)
                            ]),
                            _createElementVNode("h5", _hoisted_24, [
                              _createVNode(_component_TranslatedText, { path: "references.referee.summary" })
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_TextArea, {
                                value: _ctx.employerReferenceRecordModel?.summary,
                                error: _ctx.errorModelEmployerReference['summary'],
                                disabled: 
                    _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                  ,
                                onChange: handleInputChange,
                                label: "references.please-specify",
                                name: "summary",
                                id: "summary",
                                rows: 3,
                                placeholder: "form.placeholder",
                                labelAlwaysActive: "",
                                required: true
                              }, null, 8, ["value", "error", "disabled", "onChange"]),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.charCount(_ctx.employerReferenceRecordModel, "summary", 1000)), 1)
                            ]),
                            _createElementVNode("h5", _hoisted_27, [
                              _createVNode(_component_TranslatedText, { path: "references.referee.additional-information" })
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_TextArea, {
                                value: 
                    _ctx.employerReferenceRecordModel['additional-information']
                  ,
                                error: _ctx.errorModelEmployerReference['additional-information'],
                                disabled: 
                    _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                  ,
                                onChange: handleInputChange,
                                label: "references.please-specify",
                                name: "additional-information",
                                id: "additional-information",
                                rows: 3,
                                placeholder: "form.placeholder",
                                labelAlwaysActive: "",
                                required: true
                              }, null, 8, ["value", "error", "disabled", "onChange"]),
                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.charCount(
                    _ctx.employerReferenceRecordModel,
                    "additional-information",
                    1000
                  )), 1)
                            ])
                          ], 64))
                        : (_ctx.tenant === 'mww')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("h5", _hoisted_31, [
                                  _createVNode(_component_TranslatedText, { path: "references.referee.reason" })
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createVNode(_component_TextArea, {
                                    value: _ctx.employerReferenceRecordModel?.reasonForLeaving,
                                    error: _ctx.errorModelEmployerReference['reasonForLeaving'],
                                    disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                    onChange: handleInputChange,
                                    label: "references.please-specify",
                                    name: "reasonForLeaving",
                                    id: "reasonForLeaving",
                                    rows: 3,
                                    placeholder: "form.placeholder",
                                    labelAlwaysActive: "",
                                    required: true
                                  }, null, 8, ["value", "error", "disabled", "onChange"]),
                                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.charCount(
                      _ctx.employerReferenceRecordModel,
                      "reasonForLeaving",
                      1000
                    )), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("h5", _hoisted_35, [
                                  _createVNode(_component_TranslatedText, { path: "references.referee.reemploy" })
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createVNode(_component_TextArea, {
                                    value: _ctx.employerReferenceRecordModel?.reemploy,
                                    error: _ctx.errorModelEmployerReference['reemploy'],
                                    disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                    onChange: handleInputChange,
                                    label: "references.please-specify",
                                    name: "reemploy",
                                    id: "reemploy",
                                    rows: 3,
                                    placeholder: "form.placeholder",
                                    labelAlwaysActive: "",
                                    required: true
                                  }, null, 8, ["value", "error", "disabled", "onChange"]),
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.charCount(_ctx.employerReferenceRecordModel, "reemploy", 1000)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("h5", _hoisted_39, [
                                  _createVNode(_component_TranslatedText, { path: "references.referee.summary" })
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createVNode(_component_TextArea, {
                                    value: _ctx.employerReferenceRecordModel['summary'],
                                    error: _ctx.errorModelEmployerReference['summary'],
                                    disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                    onChange: handleInputChange,
                                    label: "references.please-specify",
                                    name: "summary",
                                    id: "summary",
                                    rows: 3,
                                    placeholder: "form.placeholder",
                                    labelAlwaysActive: "",
                                    required: true
                                  }, null, 8, ["value", "error", "disabled", "onChange"]),
                                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.charCount(_ctx.employerReferenceRecordModel, "summary", 1000)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("h5", _hoisted_43, [
                                  _createVNode(_component_TranslatedText, { path: "references.referee.assess" })
                                ])
                              ]),
                              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col sm:col-4" }, " ", -1)),
                              _createElementVNode("div", _hoisted_44, [
                                _createVNode(_component_TranslatedText, { path: "references.referee.assess.excellent" })
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _createVNode(_component_TranslatedText, { path: "references.referee.assess.good" })
                              ]),
                              _createElementVNode("div", _hoisted_46, [
                                _createVNode(_component_TranslatedText, { path: "references.referee.assess.average" })
                              ]),
                              _createElementVNode("div", _hoisted_47, [
                                _createVNode(_component_TranslatedText, { path: "references.referee.assess.poor" })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assesQuestions, (assesType) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: assesType }, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createVNode(_component_TranslatedText, {
                                      path: 'references.referee.assess.' + assesType
                                    }, null, 8, ["path"])
                                  ]),
                                  _createElementVNode("div", _hoisted_49, [
                                    _createVNode(_component_FormInput, {
                                      type: "radio",
                                      value: "excellent",
                                      error: _ctx.errorModelEmployerReference[assesType],
                                      checked: 
                      _ctx.employerReferenceRecordModel[assesType] === 'excellent'
                    ,
                                      disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                      id: assesType + 'excellent',
                                      name: assesType,
                                      label: "",
                                      onChange: handleInputChange,
                                      required: true
                                    }, null, 8, ["error", "checked", "disabled", "id", "name", "onChange"])
                                  ]),
                                  _createElementVNode("div", _hoisted_50, [
                                    _createVNode(_component_FormInput, {
                                      type: "radio",
                                      value: "good",
                                      error: _ctx.errorModelEmployerReference[assesType],
                                      checked: 
                      _ctx.employerReferenceRecordModel[assesType] === 'good'
                    ,
                                      disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                      id: assesType + 'good',
                                      name: assesType,
                                      label: "",
                                      onChange: handleInputChange,
                                      required: true
                                    }, null, 8, ["error", "checked", "disabled", "id", "name", "onChange"])
                                  ]),
                                  _createElementVNode("div", _hoisted_51, [
                                    _createVNode(_component_FormInput, {
                                      type: "radio",
                                      value: "average",
                                      error: _ctx.errorModelEmployerReference[assesType],
                                      checked: 
                      _ctx.employerReferenceRecordModel[assesType] === 'average'
                    ,
                                      disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                      id: assesType + 'average',
                                      name: assesType,
                                      label: "",
                                      onChange: handleInputChange,
                                      required: true
                                    }, null, 8, ["error", "checked", "disabled", "id", "name", "onChange"])
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    _createVNode(_component_FormInput, {
                                      type: "radio",
                                      value: "poor",
                                      error: _ctx.errorModelEmployerReference[assesType],
                                      checked: 
                      _ctx.employerReferenceRecordModel[assesType] === 'poor'
                    ,
                                      disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                      id: assesType + 'poor',
                                      name: assesType,
                                      label: "",
                                      onChange: handleInputChange,
                                      required: true
                                    }, null, 8, ["error", "checked", "disabled", "id", "name", "onChange"])
                                  ])
                                ], 64))
                              }), 128)),
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("h4", null, [
                                    _createVNode(_component_TranslatedText, { path: "references.referee.details.heading" })
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_55, [
                                _createElementVNode("div", _hoisted_56, [
                                  _createVNode(_component_FormInput, {
                                    label: "references.referee.details.name",
                                    value: _ctx.employerReferenceRecordModel.name,
                                    error: _ctx.errorModelEmployerReference['name'],
                                    disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                    onChange: handleInputChange,
                                    name: "name",
                                    id: "name",
                                    required: true
                                  }, null, 8, ["value", "error", "disabled", "onChange"]),
                                  _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.charCount(_ctx.employerReferenceRecordModel, "name", 100)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_58, [
                                  _createVNode(_component_FormInput, {
                                    label: "references.referee.details.telephone",
                                    value: _ctx.employerReferenceRecordModel.telephone,
                                    error: _ctx.errorModelEmployerReference['telephone'],
                                    disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                    onChange: handleInputChange,
                                    name: "telephone",
                                    id: "telephone",
                                    required: true
                                  }, null, 8, ["value", "error", "disabled", "onChange"]),
                                  _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.charCount(_ctx.employerReferenceRecordModel, "telephone", 11)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createVNode(_component_FormInput, {
                                    label: "references.referee.details.title",
                                    value: _ctx.employerReferenceRecordModel.title,
                                    error: _ctx.errorModelEmployerReference['title'],
                                    disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                    onChange: handleInputChange,
                                    name: "title",
                                    id: "title",
                                    required: true
                                  }, null, 8, ["value", "error", "disabled", "onChange"]),
                                  _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.charCount(_ctx.employerReferenceRecordModel, "title", 100)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                  _createVNode(_component_FormInput, {
                                    label: "references.referee.details.companyName",
                                    value: _ctx.employerReferenceRecordModel.companyName,
                                    error: _ctx.errorModelEmployerReference['companyName'],
                                    disabled: 
                      _ctx.referenceRecordModel.completed === 'yes' || _ctx.justCompleted
                    ,
                                    onChange: handleInputChange,
                                    name: "companyName",
                                    id: "companyName",
                                    required: true
                                  }, null, 8, ["value", "error", "disabled", "onChange"]),
                                  _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.charCount(_ctx.employerReferenceRecordModel, "companyName", 100)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("h5", _hoisted_66, _toDisplayString(_ctx.translateText("references.referee.telephoneEnquiry")), 1),
                                _createElementVNode("div", _hoisted_67, [
                                  _createVNode(_component_FormInput, {
                                    type: "radio",
                                    value: "yes",
                                    error: _ctx.errorModelCharacterReference['telephoneEnquiry'],
                                    checked: 
                      _ctx.employerReferenceRecordModel?.telephoneEnquiry === 'yes'
                    ,
                                    id: "telephoneEnquiryYes",
                                    name: "telephoneEnquiry",
                                    label: "common.yes",
                                    onChange: handleInputChange
                                  }, null, 8, ["error", "checked", "onChange"]),
                                  _createVNode(_component_FormInput, {
                                    type: "radio",
                                    value: "no",
                                    error: _ctx.errorModelCharacterReference['telephoneEnquiry'],
                                    checked: 
                      _ctx.employerReferenceRecordModel?.telephoneEnquiry === 'no'
                    ,
                                    id: "telephoneEnquiryNo",
                                    name: "telephoneEnquiry",
                                    label: "common.no",
                                    onChange: handleInputChange
                                  }, null, 8, ["error", "checked", "onChange"])
                                ])
                              ]),
                              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col sm:col-12" }, " ", -1))
                            ], 64))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "errors", "valid", "submitCheck", "schema"]))
                : _createCommentVNode("", true),
              (_ctx.characterReferenceRecordModel)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 1,
                    modelValue: _ctx.characterReferenceRecordModel,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.characterReferenceRecordModel) = $event)),
                    errors: _ctx.errorModelCharacterReference,
                    "onUpdate:errors": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.errorModelCharacterReference) = $event)),
                    valid: _ctx.characterReferenceValid,
                    "onUpdate:valid": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.characterReferenceValid) = $event)),
                    submitCheck: _ctx.submitCheckCharacterReferenceRef,
                    "onUpdate:submitCheck": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.submitCheckCharacterReferenceRef) = $event)),
                    schema: _ctx.schemaCharacterReference,
                    class: "grid"
                  }, {
                    default: _withCtx(({ handleInputChange }) => [
                      _createElementVNode("h3", _hoisted_68, [
                        _createVNode(_component_TranslatedText, { path: "references.responses" })
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        (_ctx.characterReferenceRecordModel !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                              _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.translateText("references.character.how-known")) + ": ", 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.characterReferenceRecordModel?.howKnown) + " ", 1),
                              _cache[14] || (_cache[14] = _createElementVNode("hr", null, null, -1))
                            ]))
                          : (_openBlock(), _createBlock(_component_TextArea, {
                              key: 1,
                              value: _ctx.characterReferenceRecordModel?.howKnown,
                              error: _ctx.errorModelCharacterReference['howKnown'],
                              disabled: true,
                              resizable: false,
                              label: "references.character.how-known",
                              name: "howKnown",
                              id: "howKnown",
                              rows: 3,
                              placeholder: "form.placeholder",
                              labelAlwaysActive: "",
                              onChange: handleInputChange
                            }, null, 8, ["value", "error", "onChange"]))
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("label", _hoisted_73, [
                          _createVNode(_component_TranslatedText, { path: "references.is-information-correct" })
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _createVNode(_component_FormInput, {
                            type: "radio",
                            value: "true",
                            error: _ctx.errorModelCharacterReference['infoCorrect'],
                            checked: _ctx.confirmed === 'true',
                            id: "infoCorrectYes",
                            name: "infoCorrect",
                            label: "common.yes",
                            onChange: handleInputChange
                          }, null, 8, ["error", "checked", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createVNode(_component_FormInput, {
                            type: "radio",
                            value: "false",
                            error: _ctx.errorModelCharacterReference['infoCorrect'],
                            checked: _ctx.confirmed === 'false',
                            id: "infoCorrectNo",
                            name: "infoCorrect",
                            label: "common.no",
                            onChange: handleInputChange,
                            labelAlwaysActive: ""
                          }, null, 8, ["error", "checked", "onChange"])
                        ])
                      ]),
                      (_ctx.tenant === 'north')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                            _createVNode(_component_TextArea, {
                              value: 
                    _ctx.characterReferenceRecordModel['additional-information']
                  ,
                              error: 
                    _ctx.errorModelCharacterReference['additional-information']
                  ,
                              disabled: _ctx.referenceRecord.completed || _ctx.justCompleted,
                              label: "references.referee.additional-information-character",
                              name: "additional-information",
                              id: "additional-information",
                              rows: 3,
                              placeholder: "form.placeholder",
                              labelAlwaysActive: "",
                              onChange: handleInputChange,
                              required: true
                            }, null, 8, ["value", "error", "disabled", "onChange"]),
                            _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.charCount(
                    _ctx.errorModelCharacterReference,
                    "additional-information",
                    1000
                  )), 1)
                          ]))
                        : (_ctx.tenant === 'mww')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                              _createVNode(_component_TextArea, {
                                value: 
                    _ctx.characterReferenceRecordModel['additional-information']
                  ,
                                error: 
                    _ctx.errorModelCharacterReference['additional-information']
                  ,
                                disabled: _ctx.referenceRecord.completed || _ctx.justCompleted,
                                label: "references.referee.additional-information-character",
                                name: "additional-information",
                                id: "additional-information",
                                rows: 3,
                                placeholder: "form.placeholder",
                                labelAlwaysActive: "",
                                onChange: handleInputChange,
                                required: true
                              }, null, 8, ["value", "error", "disabled", "onChange"]),
                              _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.charCount(
                    _ctx.errorModelCharacterReference,
                    "additional-information",
                    1000
                  )), 1)
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "errors", "valid", "submitCheck", "schema"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_Button, {
                  disabled: _ctx.referenceRecord.completed || _ctx.justCompleted,
                  text: "common.submit",
                  onClick: _ctx.submitReferenceRecord
                }, null, 8, ["disabled", "onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}